const DICTIONARIES = {
  en: {
    additional_trip_notes: 'additional trip notes: {{tripNotes}}',
    error_submit: {
      has_empty_files: 'Some Payable has no file uploaded',
      has_empty_hold_reason: 'Please input your hold reason',
      has_empty_cancel_reason: 'Please input your cancellation reason',
      has_requested_payable: 'Some payable selected is already requested and can not be sumitted',
      must_save_reason: 'Click “Save” to save the reason',
    },
    manage_file_modal: {
      footer: 'Frequent supported format from Google drive or Locus.',
      must_save_link_first_error: 'File link must be saved first',
      subtitle: 'Add files by saving their URL link and click them to view.',
      title: 'Manage Files {{x}}',
    },
    no_x_uploaded: 'There is no {{x}} uploaded',
    payment_action_modal: {
      change_final_amount: 'Change Final Amount',
      days_with_do: 'Days with DO',
      days_without_do: 'Days without DO',
      enter_reason: 'Please enter a reason',
      final_amount: 'Final Amount',
      final_amount_succesfully_saved: 'Final amount succesfully saved',
      overriden_by_final_amount: 'Overriden by Final Amount',
      reason_change_final_amount: 'Reason for Change in Final Amount',
      rental_payment: 'Rental Payment',
      review_payment: 'Review Payment',
      total_days_with_do: 'Total days with DO',
      total_days_without_do: 'Total days without DO',
      total_tip_payment: 'Total TIP Payment',
      total_working_days: 'Total working days',
      tooltip_days_with_do: 'The total days with DO is calculated 40 days after the contract starts.',
      tooltip_days_without_do: 'The total days without DO is calculated 40 days after the contract starts.',
      tooltip_final_amount: 'The actual rental payment will be reflected in the final amount',
    },
    do_list_modal: {
      delivery_date: 'Delivery Date',
      do_number: 'DO Number',
      subtitle: 'Only Delivery Orders that take place within 40 days after the contract starts will be shown below',
      title: 'Delivery Order List',
    },
    total_days_with_do: 'Total Days With DO',
    total_days_without_do: 'Total Days Without DO',
    total_working_days: 'Total Working Days',
  },
};

export default DICTIONARIES;
